module.exports = __webpack_public_path__ + "img/service-221.8a071cca.png";